import {RangeModel} from '../shared/range.model';
import {QuestionExtendedModel} from '../question-extended.model';

export class UnitHouseModel extends QuestionExtendedModel {

  model = {
    unitRange: new RangeModel(),
    tensRange: new RangeModel(),
    hundredsRange: new RangeModel(),
    thousandsRange: new RangeModel(),
    tenThousandsRange: new RangeModel(),
    hundredThousandsRange: new RangeModel(),
    numUnits: 2
  };

  static generateModel(json: any): UnitHouseModel {

    const q = new UnitHouseModel();
    const model = json.model;

    if (model) {

      if (model.unitRange) {
        q.model.unitRange = RangeModel.generateModel(model.unitRange);
      }

      if (model.tensRange) {
        q.model.tensRange = RangeModel.generateModel(model.tensRange);
      }

      if (model.hundredsRange) {
        q.model.hundredsRange = RangeModel.generateModel(model.hundredsRange);
      }

      if (model.thousandsRange) {
        q.model.thousandsRange = RangeModel.generateModel(model.thousandsRange);
      }

      if (model.tenThousandsRange) {
        q.model.tenThousandsRange = RangeModel.generateModel(model.tenThousandsRange);
      }

      if (model.hundredThousandsRange) {
        q.model.hundredThousandsRange = RangeModel.generateModel(model.hundredThousandsRange);
      }

      q.model.numUnits = model.numUnits;

    }

    return q;

  }

}
